// import AnswerRow from './components/v3/AnswerRow'
// import AnswerRowAccordion from './components/v3/AnswerRowAccordion'
import SharingView from './components/SharingView'
import ReviewSharedForm from './components/ReviewSharedForm'
import { handle__react_renders } from './rendering'


const COMPONENTS = {
  SharingView,
  ReviewSharedForm
}

export default () => {
  handle__react_renders(COMPONENTS);
}
